import { store } from '../stores/mainStore';
//import { throttle } from 'lodash';


export function preload() {
	const m = window.manager;
	let scene = this;
	let showSize = false;
	store.phaserLoading = true;
	console.log('phaser loading');

	this.load.once('complete', function () {
		console.log('phaser load complete');
		store.phaserLoading = false;
		if (store.tutorialMode) {
			store.tutorialState = 'avaOpponent';
		}
	});

	this.load.on('progress', v => {
		store.phaserLoadPercentage = Math.floor(v * 100);
	});

	this.load.on('loaderror', function (fileObj) {
		console.log('phaser loadERROR ' + fileObj);
	});

	if(m.sceneRestarting !== true) {
	//if (~~window.location.port >= 3000 || window.location.hash === '#dev') {
		this.load.audioSprite('sfx', m.assetURL + '/sounds/audio_web.json', [
			m.assetURL + '/sounds/audio_web.ogg',
			m.assetURL + '/sounds/audio_web.mp3',
			m.assetURL + '/sounds/audio_web.m4a'
		]);
	}

	const loadMultiAtlas = (keyName, jsonPath, assetPath) => {
		if(!this.textures.exists(keyName)) {
			console.log("LOADING MULTIATLAS: "+keyName);
			this.load.multiatlas(keyName, jsonPath, assetPath);
		}
	}
	const loadSpriteSheet = (keyName, asset, obj, sideLoad=false) => {
		if(!this.textures.exists(keyName)) {
			if(sideLoad) {
				store.phaserSideLoadSpriteSheets.push({keyName: keyName, asset: asset, obj: obj});
			} else {
				if(showSize) {
					get_filesize(asset, function(size) {
						console.log('LOADING SPRITESHEET: '+asset+'\t\t SIZE: '+size);
						scene.load.spritesheet(keyName, asset, obj);
					});
				} else {
					console.log("LOADING SPRITESHEET: "+keyName);
					scene.load.spritesheet(keyName, asset, obj);
				}
			}
		}
	}
	const loadImage = (keyName, asset, sideLoad=false) => {
		if(!this.textures.exists(keyName)) {
			if(sideLoad) {
				store.phaserSideLoadImages.push({keyName: keyName, asset: asset});
			} else {
				if(showSize) {
					get_filesize(asset, function(size) {
						console.log('LOADING IMAGE: '+asset+'\t\t SIZE: '+size);
						scene.load.image(keyName, asset);
					});
				} else {
					console.log("LOADING IMAGE: "+asset);
					scene.load.image(keyName, asset);
				}
			}
		}
	}
	function get_filesize(url, callback) {
		var xhr = new XMLHttpRequest();
		xhr.open("HEAD", url, true); // Notice "HEAD" instead of "GET",
									 //  to get only the header
		xhr.onreadystatechange = function() {
			if (this.readyState === this.DONE) {
				callback(parseInt(xhr.getResponseHeader("Content-Length")));
			}
		};
		xhr.send();
	}
	
	let lang = store.validLanguage;

	//need for all games;
	loadMultiAtlas(
		'language',
		m.assetURL + '/languages/' + lang + '-phaser.json?cache=' + Date.now().toString(),
		m.assetURL + '/languages'
	);
	loadMultiAtlas('common', m.assetURL + '/sprite_sheets/common-phaser.json', m.assetURL + '/sprite_sheets');

	// skins instead of customAssets or Themes
	const skinPath = m.assetURL + '/skin/';
	loadSpriteSheet('cup_sheet', skinPath + 'cup_sheet.png', {frameWidth: 180, frameHeight: 185});
	loadSpriteSheet('dice3D_sheet', skinPath + 'dice3D_sheet.png', {frameWidth: 128, frameHeight: 128});
	loadSpriteSheet('dice2D_sheet', skinPath + 'dice2D_sheet.png', {frameWidth: 226, frameHeight: 226});
	loadSpriteSheet('dice2D_sheet_64', skinPath + 'dice2D_sheet_64.png', {frameWidth: 64, frameHeight: 64});
	loadSpriteSheet('suits', skinPath + 'suits.png', {frameWidth: 54, frameHeight: 57});
	loadImage('gameBkg', skinPath + 'gameBkg.jpg');
	loadImage('playfieldFrame', skinPath + 'playfieldFrame.png');

	loadSpriteSheet('logo_dice_sheet', m.assetURL + '/skillz/custom/logo_grid_4.png', {frameWidth: 223, frameHeight: 225});
	loadSpriteSheet('goalPanel', m.assetURL + '/sprite_sheets/goal_panel.png?v=1', {
		frameWidth: 306,
		frameHeight: 77,
	});

	loadSpriteSheet('flair', m.assetURL + '/sprite_sheets/dice_select_highlight/' + lang + '.png?v=1', {
		frameWidth: 338,
		frameHeight: 336,
	});
	loadSpriteSheet('flairYellowDot', m.assetURL + '/sprite_sheets/dice_select_highlight_ftue/' + lang + '.png?v=1', {
		frameWidth: 338,
		frameHeight: 336,
	});
	loadSpriteSheet('selectDice', m.assetURL + '/sprite_sheets/msg_select_dice/' + lang + '.png?v=1', {
		frameWidth: 494,
		frameHeight: 79,
	});
	loadMultiAtlas(
		'floatingStars',
		m.assetURL + '/sprite_sheets/floatingStars.json',
		m.assetURL + '/sprite_sheets'
	);
	loadMultiAtlas('poofNoCloud', m.assetURL + '/sprite_sheets/poofNoCloud.json', m.assetURL + '/sprite_sheets');
	loadMultiAtlas('swirl', m.assetURL + '/sprite_sheets/swirl.json', m.assetURL + '/sprite_sheets');

	loadSpriteSheet('button_help', m.assetURL + '/btn_help.png', {
		frameWidth: 85,
		frameHeight: 81,
	});
	loadSpriteSheet('button_zoom', m.assetURL + '/btn_zoom.png', {
		frameWidth: 82,
		frameHeight: 86,
	});
	loadSpriteSheet('zoomer', m.assetURL + '/zoomers.png', {
		frameWidth: 250,
		frameHeight: 250,
	});
	loadSpriteSheet('hand', m.assetURL + '/hand_sheet.png', {
		frameWidth: 178,
		frameHeight: 181,
	});
	loadImage('border', m.assetURL + '/game/bumper320thick.jpg'); //left out of sprite sheet.
	loadImage('dimPanel', m.assetURL + '/game/dimPanel.png');
	loadImage('profile_default', m.assetURL + '/profile/profile_default.jpg');
	loadImage('popper_button', m.assetURL + '/skillz/play_on_no_text.png');
	loadImage('popper_button_grey', m.assetURL + '/skillz/play_off_no_text.png');
	loadImage('resultPanel', m.assetURL + '/popups/box_results_balance_well.png');
	loadImage('stakePanel', m.assetURL + '/popups/box_stakes_balance_well.png');
	loadImage('settings', m.assetURL + '/buttons/icon_gear.png');
	loadImage('coin', m.assetURL + '/coin_front.png');
	loadImage('multi_2', m.assetURL + '/multiplier/2x_single.png');
	loadImage('multi_4', m.assetURL + '/multiplier/4x_single.png');
	loadImage('multi_6', m.assetURL + '/multiplier/6x_single.png');
	loadImage('multi_10', m.assetURL + '/multiplier/10x_single.png');

	loadMultiAtlas(
		'tutorial',
		m.assetURL + '/languages/' + lang + '-tutorial.json?cache=' + Date.now().toString(),
		m.assetURL + '/languages'
	);

	//not needed for FTUE
	store.ftueMode = !store.user.hasSeenOrSkippedTutorial;
	if(store.tutorialMode || store.ftueMode) {
		//ftue only assets
		loadImage('short_tutorial_banner_epic', m.assetURL + '/languages/' + lang + '/short_tutorial_banner_epic.png');
		loadImage('short_tutorial_msg_roll', m.assetURL + '/languages/' + lang + '/short_tutorial_msg_roll.png');
	}
	
	let sideLoadRest = false;
	if(store.tutorialMode || store.ftueMode) {
		if(store.phaserSideLoadImages.length > 0 || store.phaserSideLoadSpriteSheets.length > 0)
			return;	//below files already marked for sideloading.
		sideLoadRest = true;
	}
	
	loadImage('btn_close', m.assetURL + '/buttons/btn_close.png'  , sideLoadRest);
	loadImage('scorecard_3', m.assetURL + '/skillz/panel_skillz_scorecard_top_3_rows.png' , sideLoadRest);
	loadImage('scorecard_4', m.assetURL + '/skillz/panel_skillz_scorecard_top_4_rows.png' , sideLoadRest);
	loadImage('scorecard_5', m.assetURL + '/skillz/panel_skillz_scorecard_top_5_rows.png' , sideLoadRest);
	loadImage('scoreBkg', m.assetURL + '/skillz/panel_skillz_scorecard_blue.png' , sideLoadRest);
	loadImage('scorecard_footer', m.assetURL + '/skillz/scorecard_footer.png' , sideLoadRest);
	loadImage('fill_meter', m.assetURL + '/skillz/fill_meter.png' , sideLoadRest);
	loadImage('tutorial_box', m.assetURL + '/skillz/tutorial_boxes.png' , sideLoadRest);
	loadImage('wild', m.assetURL + '/skillz/wild.png' , sideLoadRest);
	loadImage('bestHands', m.assetURL + '/skillz/bestPlural.png' , sideLoadRest);
	loadImage('bestHand', m.assetURL + '/skillz/bestSingl.png' , sideLoadRest);
	loadImage('whiteArrow', m.assetURL + '/skillz/arrow_white.png' , sideLoadRest);
	loadImage('btn_android', m.assetURL + '/buttons/download_for_android.png', sideLoadRest);
	loadImage('btn_appstore', m.assetURL + '/buttons/btn_download_appstore.png', sideLoadRest);

	loadImage('ava_hint_body', m.assetURL + '/hint/ava_hint_body_blank.png' , sideLoadRest);
	loadImage('ava_hint_bubble', m.assetURL + '/hint/hint_bubble.png' , sideLoadRest);

	m.sceneNeedsToReload = false;
	//end discreet loaded images:
}
